import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const DataTableColumnHeaders = ({ headerGroups }) => {
	if (headerGroups) {
		return headerGroups.map((headerGroup, index) => (
			<thead
				key={`hgroup-${index}`}
				style={{
					MozUserSelect: "none",
					WebkitUserSelect: "none",
					msUserSelect: "none",
				}}
			>
				<tr key={`tr-${index}`} {...headerGroup.getHeaderGroupProps()}>
					{headerGroup.headers.map((column, index2) => (
						<th scope="col" key={`col-${index}-${index2}`}>
							<div
								{...column.getHeaderProps(
									column.getSortByToggleProps()
								)}
								key={`colHeader-${index2}`}
							>
								{column.render("Header")}
								{column.isSorted ? (
									<FontAwesomeIcon
										className="ms-1"
										icon={
											column.isSortedDesc
												? faArrowUp
												: faArrowDown
										}
									/>
								) : (
									""
								)}
							</div>
							<div key={`colFilter-${index2}`}>
								{column.canFilter && column.isFilter !== false
									? column.render("Filter")
									: null}
							</div>
						</th>
					))}
				</tr>
			</thead>
		));
	}
	return null;
};
